import { LoadingSpinner } from "chameleon/lib/components";

import { isPayInProgressLoaderContainer } from "checkout-experience/layouts/checkout-experience.css";
import { PaymentType } from "checkout-query-client/types/form-types";

const PayInProgressLoader = ({
  paymentType,
  isPayInProgress,
}: {
  paymentType?: PaymentType;
  isPayInProgress?: boolean;
}) => {
  if (
    (paymentType === PaymentType.googlePay ||
      paymentType === PaymentType.applePay) &&
    isPayInProgress
  ) {
    return (
      <div
        data-testid="pay-in-progress-loader"
        className={isPayInProgressLoaderContainer}
      >
        <LoadingSpinner />
      </div>
    );
  }

  return null;
};

export default PayInProgressLoader;
